import React from 'react'
import { Link } from 'react-router-dom'
import { FaCheck, FaTimes } from 'react-icons/fa'
import dayjs from 'dayjs'
import { formTypeToRoute } from '../constants/urls'

//https://react-table-v7-docs.netlify.app/docs/api/useSortBy  ← Official Docs for version 7 of react table

// There are 3 different available sortTypes for the grids: ‘datetime', ‘basic’, 'alphanumeric’

// basic is the generic sort function if a > b then 1 else - 1 which works perfectly for numbers
// datetime is the same as basic but the values are parsed into dates with getTime() to convert the date to miliseconds since epoch
// alphanumeric is a custom function that sorts strings by dividing numbers from letter and from symbols
// Hard to explain with words… check ouit the docs
const dateFormat = 'MM/DD/YYYY hh:mm:ss A'

const dateFilterFn = (rows, id, filterValues) => {
    return rows.filter((r) => {
        // return r.values[id].startsWith(filterValues)
        return r.values[id].includes(filterValues)
    })
}

const createDateField = (col) => ({
    Header: () => <div>{col}</div>,
    id: col, 
    accessor: row => dayjs(row[col]).isValid() ? dayjs(row[col]).format(dateFormat) : dayjs('1/1/1002').format('MM/DD/YYYY'),
    Cell: ({ cell }) => (<div>{
        dayjs(cell.value).format(dateFormat).includes('01/01/1002') ? '' : dayjs(cell.value).format(dateFormat)
    }</div>),
    filter: dateFilterFn,
    sortType: (a, b) => dayjs(b.values[col]).toDate() - dayjs(a.values[col]).toDate()
})

const parseColumns = (data, dateColumns) => {
    if (!(data && data.length)) {
        return []
    }

    const exampleRow = data[0]
    const columns = Object.keys(exampleRow).map(col => {
        const isDate = dateColumns.indexOf(col) !== -1
        return isDate 
            ? createDateField(col) 
            : ({
                Header: () => <div>{col}</div>,
                id: col,
                accessor: col,
                Cell: ({ cell }) => (<div>{cell.value}</div>),
            }) 
    })
    return columns
}

const parseColumnsWithConfig = (data, config) => {
    if (data && data.length && config && config.length) {
        const exampleRow = data[0]
        const columns = Object.keys(exampleRow).map(col => {
            let columnName = col
            const configObj = config.find(x => x.ColumnName === col)
            if (configObj) {
                columnName = configObj.ColumnTitle
            }
            return {
                Header: () => <div>{columnName}</div>,
                accessor: col,
                Cell: ({ cell }) => {
                    let value = cell.value
                    if (configObj) {
                        if (configObj.Values) {
                            let configValue = configObj.Values.find(x => x.code != null && value != null ? x.code === value || x.code.toString() === value.toString() : null)
                            value = configValue && configValue.codedescription  ? configValue.codedescription : null
                        }
                    }
                    return <div>{value}</div>
                },
            }
        })
        return columns
    } else {
        return []
    }
}

const getInProgressColumns = (data, setConfirmDeleteModalData) => {
    const columns = parseColumns(data, ['Modify Date']).filter(
        x => x.accessor !== 'Link' && x.accessor !== 'IsValid'
    )
    
    return [
        {
            Header: () => <div>Validation Status</div>,
            accessor: 'IsValid',
            Cell: ({ cell }) => {
                const isValid = cell.row.values.IsValid === 'Pass'
                return (
                    <div>
                        {isValid ? (
                            <span className="icon-text">
                                <span className="icon">
                                    <i className="icon">
                                        <FaCheck className="has-text-success" />
                                    </i>{' '}
                                </span>
                                <span>Pass </span>
                            </span>
                        ) : (
                            <span className="icon-text">
                                <span className="icon">
                                    <i className="icon">
                                        <FaTimes className="has-text-danger" />
                                    </i>{' '}
                                </span>
                                <span>Fail </span>
                            </span>
                        )}
                    </div>
                )
            },
        },
        ...columns,
        {
            Header: () => <div>Actions</div>,
            accessor: 'nothing',
            disableSortBy: true,
            disableFilters: true,
            Cell: ({ cell }) => {
                const recordValues = cell.row.values
                const route = formTypeToRoute[recordValues['Form Type']] || 'form'
                return (
                    <div>
                        <Link
                            to={{
                                pathname: recordValues["Is EDD?"] === 'Yes' && recordValues['Form Type'] === 'Sample Result EDD'
                                    ? `submissions/edd/${recordValues[`Form ID`]}`
                                    : `submissions/${route}/${recordValues[`Form ID`]}`
                                    // state: getCellGSAIDObject(cell)
                            }}
                        >
                    Edit
                        </Link>
                        {` | `}
                        <div
                            className="link inline-block"
                            onClick={() =>
                                setConfirmDeleteModalData({ 
                                    display: true,
                                    uploadId: recordValues['Form ID'],
                                    formType: recordValues['Form Type'],
                                    submittingEDD: recordValues['Submitting EDD'],
                                })
                            }
                        >
                            Delete
                        </div>
                    </div>
                )
            },
        },
    ]
}

const getSubmittedColumns = (data, isReviewer, activeTab) => {
    const columns = parseColumns(data, ["Submitted Date", "Approved / Denied Date"]).filter(x => x.accessor !== 'Link' && x.accessor !== 'IsValid')
    const validationStatusColumn = {
        Header: () => <div>Validation Status</div>,
        accessor: 'IsValid',
        Cell: ({ cell }) => {
            const isValid = cell.row.values.IsValid === 'Pass'
            return (
                <div>
                    {isValid ? (
                        <span className="icon-text">
                            <span className="icon">
                                <i className="icon">
                                    <FaCheck className="has-text-success" />
                                </i>{' '}
                            </span>
                            <span>Pass </span>
                        </span>
                    ) : (
                        <span className="icon-text">
                            <span className="icon">
                                <i className="icon">
                                    <FaTimes className="has-text-danger" />
                                </i>{' '}
                            </span>
                            <span>Fail </span>
                        </span>
                    )}
                </div>
            )
        },
    }
    return [
        ...(activeTab === 'submitted' ? [validationStatusColumn] : []),
        ...columns,
        {
            Header: () => <div>Actions</div>,
            accessor: 'none',
            disableSortBy: true,
            disableFilters: true,
            Cell: ({ cell }) => {
                const recordValues = cell.row.values
                const route = formTypeToRoute[recordValues['Form Type']] || 'form'
                return (
                    <div>
                        <Link 
                            to={{
                                pathname: recordValues["Is EDD?"] === 'Yes' && recordValues['Form Type'] === 'Sample Result EDD'
                                    ? `submissions/edd/view/${recordValues[`Form ID`]}`
                                    : `submissions/${route}/view/${recordValues[`Form ID`]}`,
                                state: { clearinghouse: recordValues["Clearinghouse Number"], from: activeTab }  
                            }}
                        >
                            View
                        </Link>
                        {isReviewer && recordValues.Status === "Submitted" && (
                            <>
                                {` | `}
                                <Link
                                    to={{
                                        pathname: recordValues["Is EDD?"] === 'Yes' && recordValues['Form Type'] === 'Sample Result EDD'
                                            ? `submissions/edd/review/${recordValues[`Form ID`]}`
                                            : `submissions/${route}/review/${recordValues[`Form ID`]}`,
                                        state: { clearinghouse: recordValues["Clearinghouse Number"] }  
                                    }}
                                >
                                    Review
                                </Link>
                            </>
                        )}
                    </div>
                )
            },
        },
    ]
}

const getEmptyColumnObject = columns => {
    return columns.reduce((acc, curr) => {
        const field = curr.accessor
        return {
            ...acc,
            [field]: null,
        }
    }, {})
}

export {
    getInProgressColumns,
    getSubmittedColumns,
    parseColumns,
    getEmptyColumnObject,
    parseColumnsWithConfig,
}
